// // import React, { useState, useEffect } from "react";
// // import { Container, Row, Col, Image, Form } from "react-bootstrap";
// // import { FaEdit, FaSave } from "react-icons/fa";
// // import aboutImageDefault from "../Profile/profileimage/shoert.jpg";

// // const Cateringaboutus = () => {
// //     const [isEditing, setIsEditing] = useState(false);
// //     const [aboutText, setAboutText] = useState({ aboutUs: "" });
// //     const [previewImage, setPreviewImage] = useState(aboutImageDefault);
// //     const [imageFile, setImageFile] = useState(null);
// //     const [vendorId, setVendorId] = useState(null);
// //     const [aboutUsId, setAboutUsId] = useState(null);

// //     useEffect(() => {
// //         const storedVendorId = localStorage.getItem("vendorId");
// //         setVendorId(storedVendorId);
// //     }, []);

// //     useEffect(() => {
// //         if (vendorId) fetchAboutUsData(vendorId);
// //     }, [vendorId]);

// //     const fetchAboutUsData = async (vendorId) => {
// //         const token = localStorage.getItem("authToken");
// //         if (!token || !vendorId) return;

// //         try {
// //             const response = await fetch(
// //                 `http://testing.maamaas.com:8080/catering/api/aboutus/${vendorId}`,
// //                 { headers: { Authorization: `Bearer ${token}` } }
// //             );

// //             if (response.ok) {
// //                 const data = await response.json();
// //                 setAboutText({ aboutUs: data.aboutUs || "" });
// //                 setAboutUsId(data.aboutUsId || null);

// //                 // If image URL exists, use it for preview
// //                 if (data.image) {
// //                     setPreviewImage(data.image);
// //                 } else {
// //                     setPreviewImage(aboutImageDefault);
// //                 }
// //             }
// //         } catch (err) {
// //             console.error("Error fetching About Us:", err);
// //         }
// //     };

// //     const handleTextChange = (e) => setAboutText({ ...aboutText, aboutUs: e.target.value });

// //     const handleImageChange = (e) => {
// //         const file = e.target.files[0];
// //         if (!file) return;
// //         setImageFile(file);

// //         const reader = new FileReader();
// //         reader.onloadend = () => setPreviewImage(reader.result);
// //         reader.readAsDataURL(file);
// //     };

// //     const sendFormData = async (url, method) => {
// //         const token = localStorage.getItem("authToken");
// //         if (!vendorId || !token) return alert("Vendor ID or auth token missing");

// //         if (!aboutText.aboutUs.trim()) return alert("Please enter About Us text");

// //         const formData = new FormData();
// //         formData.append(
// //             "aboutUsData",
// //             new Blob([JSON.stringify({ aboutUs: aboutText.aboutUs })], { type: "application/json" })
// //         );

// //         if (imageFile) {
// //             formData.append("image", imageFile);
// //         }

// //         try {
// //             const response = await fetch(url, {
// //                 method,
// //                 headers: { Authorization: `Bearer ${token}` }, // Do NOT set Content-Type
// //                 body: formData,
// //             });

// //             if (response.ok) {
// //                 alert(method === "POST" ? "Added successfully!" : "Updated successfully!");
// //                 fetchAboutUsData(vendorId);
// //             } else {
// //                 const err = await response.json();
// //                 alert(`Failed: ${err.message || "Unknown error"}`);
// //             }
// //         } catch (error) {
// //             console.error("Error submitting form:", error);
// //             alert("Something went wrong. Please try again.");
// //         }
// //     };

// //     const handleAddAboutUs = async () => {
// //         const url = `http://testing.maamaas.com:8080/catering/api/vendor/aboutus/add/${vendorId}`;
// //         await sendFormData(url, "POST");
// //     };

// //     const handleEditSaveToggle = async () => {
// //         if (isEditing && aboutUsId) {
// //             const url = `http://testing.maamaas.com:8080/catering/api/vendor/aboutus/update/${aboutUsId}`;
// //             await sendFormData(url, "PUT");
// //         }
// //         setIsEditing((prev) => !prev);
// //     };

// //     return (
// //         <Container fluid className="py-4">
// //             <Row style={{ border: "1px solid #bbb", borderRadius: "5px" }} className="align-items-center">
// //                 <div className="d-flex justify-content-center w-100 px-4 pt-3">
// //                     <h1 style={{ color: "#b15dc6", fontWeight: "bold", textAlign: "center", marginBottom: "10px" }}>
// //                         ABOUT US
// //                     </h1>

// //                     <button onClick={handleAddAboutUs} style={buttonStyle}>Add+</button>
// //                     <button onClick={handleEditSaveToggle} style={buttonStyle}>
// //                         {isEditing ? <FaSave /> : <FaEdit />}
// //                     </button>
// //                 </div>

// //                 <Col md={6} className="p-4">
// //                     <Form.Control
// //                         as="textarea"
// //                         rows={10}
// //                         value={aboutText.aboutUs}
// //                         onChange={handleTextChange}
// //                         readOnly={!isEditing}
// //                         placeholder="Write about us..."
// //                         style={styles.text}
// //                     />
// //                 </Col>

// //                 <Col md={6} className="text-center p-4">
// //                     <div className="position-relative d-inline-block">
// //                         {isEditing && (
// //                             <input
// //                                 type="file"
// //                                 accept="image/*"
// //                                 id="imageUpload"
// //                                 style={{ display: "none" }}
// //                                 onChange={handleImageChange}
// //                             />
// //                         )}
// //                         <label htmlFor={isEditing ? "imageUpload" : ""} style={{ cursor: isEditing ? "pointer" : "default" }}>
// //                             <Image src={previewImage} alt="About Maamaa's Restaurant" fluid rounded style={styles.image} />
// //                         </label>
// //                     </div>
// //                 </Col>
// //             </Row>
// //         </Container>
// //     );
// // };

// // const buttonStyle = {
// //     height: "35px",
// //     borderRadius: "5px",
// //     border: "none",
// //     background: "#b15cd6",
// //     color: "#fff",
// //     fontWeight: "bold",
// //     cursor: "pointer",
// //     width: "80px",
// //     marginLeft: "20px",
// //     marginTop: "8px",
// //     display: "flex",
// //     alignItems: "center",
// //     justifyContent: "center",
// //     gap: "5px",
// // };

// // const styles = {
// //     image: {
// //         width: "100%",
// //         objectFit: "cover",
// //         borderRadius: "12px",
// //         height: "310px",
// //         maxHeight: "350px",
// //         marginTop: "-20px",
// //         boxShadow: "0 4px 16px rgba(0,0,0,0.1)",
// //     },
// //     text: {
// //         fontSize: "16px",
// //         color: "#333",
// //         lineHeight: "1.8",
// //         textAlign: "justify",
// //         border: "none",
// //         fontFamily: "math",
// //         resize: "none",
// //         outline: "none",
// //     },
// // };

// // export default Cateringaboutus;





// import React, { useState, useEffect, useRef } from "react";
// import { Container, Row, Image, Form } from "react-bootstrap";
// import aboutImageDefault from "../Profile/profileimage/shoert.jpg";

// const Cateringaboutus = () => {
//   const [aboutText, setAboutText] = useState({ aboutUs: "" });
//   const [previewImage, setPreviewImage] = useState(aboutImageDefault);
//   const [imageFile, setImageFile] = useState(null);
//   const [vendorId, setVendorId] = useState(null);
//   const [aboutUsId, setAboutUsId] = useState(null);

//   // Editing states
//   const [isTextEditing, setIsTextEditing] = useState(false);
//   const [isImageEditing, setIsImageEditing] = useState(false);

//   // ref for hidden file input
//   const fileInputRef = useRef(null);

//   // Responsive state
//   const [windowWidth, setWindowWidth] = useState(window.innerWidth);
//   const isMobile = windowWidth <= 768;
//   const isTablet = windowWidth > 768 && windowWidth <= 1024;

//   useEffect(() => {
//     const handleResize = () => setWindowWidth(window.innerWidth);
//     window.addEventListener("resize", handleResize);
//     return () => window.removeEventListener("resize", handleResize);
//   }, []);

//   useEffect(() => {
//     const storedVendorId = localStorage.getItem("vendorId");
//     setVendorId(storedVendorId);
//   }, []);

//   useEffect(() => {
//     if (vendorId) fetchAboutUsData(vendorId);
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [vendorId]);

//   const fetchAboutUsData = async () => {
//     const token = localStorage.getItem("authToken");
//     if (!token || !vendorId) return;

//     try {
//       const response = await fetch(
//         `http://testing.maamaas.com:8080/catering/api/aboutus/${vendorId}`,
//         { headers: { Authorization: `Bearer ${token}` } }
//       );

//       if (response.ok) {
//         const data = await response.json();
//         setAboutText({ aboutUs: data.aboutUs || "" });
//         setAboutUsId(data.aboutUsId || null);

//         if (data.image) {
//           setPreviewImage(data.image);
//         } else {
//           setPreviewImage(aboutImageDefault);
//         }
//       }
//     } catch (err) {
//       console.error("Error fetching About Us:", err);
//     }
//   };

//   const handleTextChange = (e) => {
//     setAboutText((prev) => ({ ...prev, aboutUs: e.target.value }));
//   };

//   const handleImageChange = (e) => {
//     const file = e.target.files?.[0];
//     if (!file) return;
//     setImageFile(file);

//     const reader = new FileReader();
//     reader.onloadend = () => setPreviewImage(reader.result);
//     reader.readAsDataURL(file);
//   };

//   const sendFormData = async (url, method) => {
//     const token = localStorage.getItem("authToken");
//     if (!vendorId || !token) return alert("Vendor ID or auth token missing");

//     if (!aboutText.aboutUs?.trim()) {
//       return alert("Please enter About Us text");
//     }

//     const formData = new FormData();

//     formData.append(
//       "aboutUsData",
//       new Blob([JSON.stringify({ aboutUs: aboutText.aboutUs })], {
//         type: "application/json",
//       })
//     );

//     if (imageFile) {
//       formData.append("image", imageFile);
//     }

//     try {
//       const response = await fetch(url, {
//         method,
//         headers: { Authorization: `Bearer ${token}` },
//         body: formData,
//       });

//       if (response.ok) {
//         alert(method === "POST" ? "Added successfully!" : "Updated successfully!");
//         await fetchAboutUsData();
//         setIsTextEditing(false);
//         setIsImageEditing(false);
//         setImageFile(null);
//         return true;
//       } else {
//         const err = await response.json().catch(() => ({}));
//         alert(`Failed: ${err.message || "Unknown error"}`);
//         return false;
//       }
//     } catch (error) {
//       console.error("Error submitting form:", error);
//       alert("Something went wrong. Please try again.");
//       return false;
//     }
//   };

//   const handleAddAboutUs = () => {
//     const url = `http://testing.maamaas.com:8080/catering/api/vendor/aboutus/add/${vendorId}`;
//     sendFormData(url, "POST");
//   };

//   const handleUpdate = () => {
//     if (!aboutUsId) return alert("No record to update");

//     const url = `http://testing.maamaas.com:8080/catering/api/vendor/aboutus/update/${aboutUsId}`;
//     sendFormData(url, "PUT");
//   };

//   const handleImageClick = () => {
//     if (isImageEditing && fileInputRef.current) {
//       fileInputRef.current.click();
//     }
//   };

//   // Responsive styles
//   const getTextAreaRows = () => {
//     if (isMobile) return 6;
//     if (isTablet) return 8;
//     return 10;
//   };

//   const getImageHeight = () => {
//     if (isMobile) return "200px";
//     if (isTablet) return "240px";
//     return "280px";
//   };

//   const getFontSize = () => {
//     if (isMobile) return "14px";
//     if (isTablet) return "15px";
//     return "16px";
//   };

//   const getHeadingSize = () => {
//     if (isMobile) return "20px";
//     if (isTablet) return "24px";
//     return "28px";
//   };

//   return (
//     <Container fluid className="py-4">
//       {/* HEADER SECTION */}
//       <Row
//         style={{
//           border: "none",
//           borderRadius: "2vmin",
//           marginTop: isMobile ? "2vh" : "4vh",
//           backgroundColor: "#b15dc6",
//         }}
//         className="align-items-center addmargintop"
//       >
//         <div
//           className="d-flex w-100 px-3 px-md-4 pt-3"
//           style={{ 
//             justifyContent: "space-between",
//             flexDirection: isMobile ? "row" : "row",
//             gap: isMobile ? "10px" : "0",
//           }}
//         >
//           <h1
//             style={{
//               color: "#ffffff",
//               fontWeight: "bold",
//               marginBottom: isMobile ? "5px" : "10px",
//               fontSize: getHeadingSize(),
//               textAlign: isMobile ? "center" : "left",
//               marginLeft: "10px"
//             }}
//             className="abouts-page-name"
//           >
//             ABOUT US
//           </h1>

//           <button onClick={handleAddAboutUs} style={{
//             height: isMobile ? "30px" : "35px",
//             borderRadius: "5px",
//             border: "none",
//             color: "#b15cd6",
//             fontWeight: "bold",
//             cursor: "pointer",
//             width: isMobile ? "70px" : "80px",
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//             fontSize: isMobile ? "12px" : "14px",
//             marginRight: "10px",
//             backgroundColor: "#ffffff"
//           }}>
//             Add+
//           </button>
//         </div>

//         {/* MAIN CONTENT CARD */}
//         <div
//           className="p-3 p-md-4"
//           style={{
//             backgroundColor: "#b15dc6",
//             margin: isMobile ? "5px" : "10px",
//             borderRadius: "2vmin",
//             display: "flex",
//             flexDirection: isMobile ? "column" : "row",
//             gap: isMobile ? "15px" : "20px",
//             width: isMobile ? "calc(100% - 10px)" : "calc(100% - 20px)",
//             justifyContent: "space-between",
//             marginTop: "0px",
//           }}
//         >
//           {/* TEXT SECTION */}
//           <div style={{
//             backgroundColor: "white",
//             borderRadius: "2vmin",
//             padding: isMobile ? "15px" : "20px",
//             width: isMobile ? "100%" : "40%",
//             boxShadow: "0 0.4vmin 1.6vmin rgba(0,0,0,0.1)",
//           }}>
//             <div className="d-flex justify-content-between align-items-center mb-2">
//               <h5 style={{ 
//                 color: "#b15dc6",
//                 fontSize: isMobile ? "16px" : "18px",
//                 fontWeight: "bold"
//               }}>Our Story</h5>

//               {/* EDIT/SAVE BUTTONS */}
//               {!isTextEditing ? (
//                 <button onClick={() => setIsTextEditing(true)} style={{
//                   border: "none",
//                   background: "#ffffff",
//                   color: "#b15cd6",
//                   fontWeight: "bold",
//                   cursor: "pointer",
//                   padding: isMobile ? "4px 8px" : "5px 10px",
//                   borderRadius: "0.6vmin",
//                   border: "1px solid #b15cd6",
//                   fontSize: isMobile ? "12px" : "14px"
//                 }}>
//                   Edit Text
//                 </button>
//               ) : (
//                 <button onClick={handleUpdate} style={{
//                   background: "#b15cd6",
//                   border: "none",
//                   padding: isMobile ? "4px 10px" : "5px 12px",
//                   borderRadius: "0.6vmin",
//                   color: "#fff",
//                   fontWeight: "bold",
//                   cursor: "pointer",
//                   fontSize: isMobile ? "12px" : "14px"
//                 }}>
//                   Save
//                 </button>
//               )}
//             </div>

//             <Form.Control
//               as="textarea"
//               rows={getTextAreaRows()}
//               className="hide-scrollbar"
//               value={aboutText.aboutUs}
//               onChange={handleTextChange}
//               readOnly={!isTextEditing}
//               placeholder="Write about us..."
//               style={{
//                 fontSize: getFontSize(),
//                 color: "#333",
//                 textAlign: "justify",
//                 border: isTextEditing ? "0.2vmin solid #b15cd6" : "0px",
//                 boxShadow: isTextEditing ? "0 0 0 0.3vmin rgba(177, 92, 214, 0.1)" : "none",
//                 backgroundColor: isTextEditing ? "white" : "#f5f4f4",
//                 borderRadius: "0.8vmin",
//                 padding: isMobile ? "8px" : "10px",
//                 resize: "none",
//                 fontFamily: "math",
//                 transition: "all 0.3s ease",
//                 width: "100%"
//               }}
//             />
//           </div>

//           {/* IMAGE SECTION */}
//           <div style={{
//             backgroundColor: "white",
//             borderRadius: "2vmin",
//             padding: isMobile ? "15px" : "20px",
//             width: isMobile ? "100%" : "55%",
//             boxShadow: "0 0.4vmin 1.6vmin rgba(0,0,0,0.1)",
//           }}>
//             <div className="d-flex justify-content-between align-items-center mb-2">
//               <h5 style={{ 
//                 color: "#b15dc6",
//                 fontSize: isMobile ? "16px" : "18px",
//                 fontWeight: "bold"
//               }}>Our Space</h5>

//               {!isImageEditing ? (
//                 <button onClick={() => setIsImageEditing(true)} style={{
//                   border: "none",
//                   background: "#ffffff",
//                   color: "#b15cd6",
//                   fontWeight: "bold",
//                   cursor: "pointer",
//                   padding: isMobile ? "4px 8px" : "5px 10px",
//                   borderRadius: "0.6vmin",
//                   border: "1px solid #b15cd6",
//                   fontSize: isMobile ? "12px" : "14px"
//                 }}>
//                   Edit Image
//                 </button>
//               ) : (
//                 <button onClick={handleUpdate} style={{
//                   background: "#b15cd6",
//                   border: "none",
//                   padding: isMobile ? "4px 10px" : "5px 12px",
//                   borderRadius: "0.6vmin",
//                   color: "#fff",
//                   fontWeight: "bold",
//                   cursor: "pointer",
//                   fontSize: isMobile ? "12px" : "14px"
//                 }}>
//                   Save
//                 </button>
//               )}
//             </div>

//             <div>
//               <input
//                 ref={fileInputRef}
//                 type="file"
//                 accept="image/*"
//                 onChange={handleImageChange}
//                 style={{ display: "none" }}
//               />

//               <div
//                 onClick={handleImageClick}
//                 role={isImageEditing ? "button" : undefined}
//                 tabIndex={isImageEditing ? 0 : undefined}
//                 onKeyPress={(e) => {
//                   if (isImageEditing && (e.key === "Enter" || e.key === " ")) {
//                     handleImageClick();
//                   }
//                 }}
//                 style={{ cursor: isImageEditing ? "pointer" : "default" }}
//               >
//                 <Image
//                   src={previewImage}
//                   alt="About Us"
//                   fluid
//                   rounded
//                   style={{
//                     width: "100%",
//                     height: getImageHeight(),
//                     objectFit: "cover",
//                     borderRadius: "1.2vmin",
//                     border: isImageEditing ? "0.2vmin solid #b15cd6" : "none",
//                   }}
//                 />
//               </div>
//             </div>
//           </div>
//         </div>
//       </Row>

//       {/* HIDE SCROLLBAR CSS */}
//       <style>
//         {`
//           .hide-scrollbar::-webkit-scrollbar {
//             display: none;
//           }
//           .hide-scrollbar {
//             scrollbar-width: none;
//           }
          
//           @media (max-width: 768px) {
//             .px-md-4 {
//               padding-left: 1rem !important;
//               padding-right: 1rem !important;
//             }
//             .p-md-4 {
//               padding: 1.5rem !important;
//             }
//           }
          
//           @media (max-width: 480px) {
//             .abouts-page-name {
//               font-size: 18px !important;
//             }
//           }
          
//           @media(max-width:768px) {
//             .addmargintop {
//               margin-top: 2vh !important;
//             }                  
//           }
//         `}
//       </style>
//     </Container>
//   );
// };

// export default Cateringaboutus;


import React, { useState, useEffect, useRef } from "react";
import { Container, Row, Image, Form } from "react-bootstrap";
import aboutImageDefault from "../Profile/profileimage/shoert.jpg";

const Cateringaboutus = () => {
  const [aboutText, setAboutText] = useState({ aboutUs: "" });
  const [previewImage, setPreviewImage] = useState(aboutImageDefault);
  const [imageFile, setImageFile] = useState(null);
  const [vendorId, setVendorId] = useState(null);
  const [aboutUsId, setAboutUsId] = useState(null);
  const [hasData, setHasData] = useState(false);

  // Editing states
  const [isTextEditing, setIsTextEditing] = useState(false);
  const [isImageEditing, setIsImageEditing] = useState(false);

  // ref for hidden file input
  const fileInputRef = useRef(null);

  // Responsive state
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const isMobile = windowWidth <= 768;
  const isTablet = windowWidth > 768 && windowWidth <= 1024;

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const storedVendorId = localStorage.getItem("vendorId");
    setVendorId(storedVendorId);
  }, []);

  useEffect(() => {
    if (vendorId) fetchAboutUsData(vendorId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [vendorId]);

  const fetchAboutUsData = async () => {
    const token = localStorage.getItem("authToken");
    if (!token || !vendorId) return;

    try {
      const response = await fetch(
        `http://testing.maamaas.com:8080/catering/api/aboutus/${vendorId}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      if (response.ok) {
        const data = await response.json();
        setAboutText({ aboutUs: data.aboutUs || "" });
        setAboutUsId(data.aboutUsId || null);
        
        // Set hasData to true if we have any data
        if (data.aboutUs || data.image) {
          setHasData(true);
        }

        if (data.image) {
          setPreviewImage(data.image);
        }
      }
    } catch (err) {
      console.error("Error fetching About Us:", err);
    }
  };

  const handleTextChange = (e) => {
    setAboutText((prev) => ({ ...prev, aboutUs: e.target.value }));
  };

  const handleImageChange = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setImageFile(file);

    const reader = new FileReader();
    reader.onloadend = () => setPreviewImage(reader.result);
    reader.readAsDataURL(file);
  };

  const sendFormData = async (url, method) => {
    const token = localStorage.getItem("authToken");
    if (!vendorId || !token) return alert("Vendor ID or auth token missing");

    if (!aboutText.aboutUs?.trim()) {
      return alert("Please enter About Us text");
    }

    const formData = new FormData();

    formData.append(
      "aboutUsData",
      new Blob([JSON.stringify({ aboutUs: aboutText.aboutUs })], {
        type: "application/json",
      })
    );

    if (imageFile) {
      formData.append("image", imageFile);
    }

    try {
      const response = await fetch(url, {
        method,
        headers: { Authorization: `Bearer ${token}` },
        body: formData,
      });

      if (response.ok) {
        alert(method === "POST" ? "Added successfully!" : "Updated successfully!");
        await fetchAboutUsData();
        setIsTextEditing(false);
        setIsImageEditing(false);
        setImageFile(null);
        setHasData(true); // Set to true after successful add/update
        return true;
      } else {
        const err = await response.json().catch(() => ({}));
        alert(`Failed: ${err.message || "Unknown error"}`);
        return false;
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      alert("Something went wrong. Please try again.");
      return false;
    }
  };

  const handleAddAboutUs = () => {
    const url = `http://testing.maamaas.com:8080/catering/api/vendor/aboutus/add/${vendorId}`;
    sendFormData(url, "POST");
  };

  const handleUpdate = () => {
    if (!aboutUsId) return alert("No record to update");

    const url = `http://testing.maamaas.com:8080/catering/api/vendor/aboutus/update/${aboutUsId}`;
    sendFormData(url, "PUT");
  };

  const handleImageClick = () => {
    if (isImageEditing && fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  // Responsive styles
  const getTextAreaRows = () => {
    if (isMobile) return 6;
    if (isTablet) return 8;
    return 10;
  };

  const getImageHeight = () => {
    if (isMobile) return "200px";
    if (isTablet) return "240px";
    return "280px";
  };

  const getFontSize = () => {
    if (isMobile) return "14px";
    if (isTablet) return "15px";
    return "16px";
  };

  const getHeadingSize = () => {
    if (isMobile) return "20px";
    if (isTablet) return "24px";
    return "28px";
  };

  return (
    <Container fluid className="py-4">
      {/* HEADER SECTION */}
      <Row
        style={{
          border: "none",
          borderRadius: "2vmin",
          marginTop: isMobile ? "2vh" : "4vh",
          backgroundColor: "#b15dc6",
        }}
        className="align-items-center addmargintop"
      >
        <div
          className="d-flex w-100 px-3 px-md-4 pt-3"
          style={{ 
            justifyContent: "space-between",
            flexDirection: isMobile ? "row" : "row",
            gap: isMobile ? "10px" : "0",
          }}
        >
          <h1
            style={{
              color: "#ffffff",
              fontWeight: "bold",
              marginBottom: isMobile ? "5px" : "10px",
              fontSize: getHeadingSize(),
              textAlign: isMobile ? "center" : "left",
              marginLeft: "10px"
            }}
            className="abouts-page-name"
          >
            ABOUT US
          </h1>

          {/* Only show Add button if no data exists */}
          {!hasData && (
            <button onClick={handleAddAboutUs} style={{
              height: isMobile ? "30px" : "35px",
              borderRadius: "5px",
              border: "none",
              color: "#b15cd6",
              fontWeight: "bold",
              cursor: "pointer",
              width: isMobile ? "70px" : "80px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: isMobile ? "12px" : "14px",
              marginRight: "10px",
              backgroundColor: "#ffffff"
            }}>
              Add+
            </button>
          )}
        </div>

        {/* MAIN CONTENT CARD */}
        <div
          className="p-3 p-md-4"
          style={{
            backgroundColor: "#b15dc6",
            margin: isMobile ? "5px" : "10px",
            borderRadius: "2vmin",
            display: "flex",
            flexDirection: isMobile ? "column" : "row",
            gap: isMobile ? "15px" : "20px",
            width: isMobile ? "calc(100% - 10px)" : "calc(100% - 20px)",
            justifyContent: "space-between",
            marginTop: "0px",
          }}
        >
          {/* TEXT SECTION */}
          <div style={{
            backgroundColor: "white",
            borderRadius: "2vmin",
            padding: isMobile ? "15px" : "20px",
            width: isMobile ? "100%" : "40%",
            boxShadow: "0 0.4vmin 1.6vmin rgba(0,0,0,0.1)",
          }}>
            <div className="d-flex justify-content-between align-items-center mb-2">
              <h5 style={{ 
                color: "#b15dc6",
                fontSize: isMobile ? "16px" : "18px",
                fontWeight: "bold"
              }}>Our Story</h5>

              {/* Only show Edit/Save buttons if we have data */}
              {hasData && !isTextEditing ? (
                <button onClick={() => setIsTextEditing(true)} style={{
                  border: "none",
                  background: "#ffffff",
                  color: "#b15cd6",
                  fontWeight: "bold",
                  cursor: "pointer",
                  padding: isMobile ? "4px 8px" : "5px 10px",
                  borderRadius: "0.6vmin",
                  border: "1px solid #b15cd6",
                  fontSize: isMobile ? "12px" : "14px"
                }}>
                  Edit Text
                </button>
              ) : hasData && isTextEditing ? (
                <button onClick={handleUpdate} style={{
                  background: "#b15cd6",
                  border: "none",
                  padding: isMobile ? "4px 10px" : "5px 12px",
                  borderRadius: "0.6vmin",
                  color: "#fff",
                  fontWeight: "bold",
                  cursor: "pointer",
                  fontSize: isMobile ? "12px" : "14px"
                }}>
                  Save
                </button>
              ) : null}
            </div>

            <Form.Control
              as="textarea"
              rows={getTextAreaRows()}
              className="hide-scrollbar"
              value={aboutText.aboutUs}
              onChange={handleTextChange}
              readOnly={!isTextEditing}
              placeholder="Share your restaurant's story, passion, and commitment to exceptional dining experiences..."
              style={{
                fontSize: getFontSize(),
                color: "#333",
                textAlign: "justify",
                border: isTextEditing ? "0.2vmin solid #b15cd6" : "0px",
                boxShadow: isTextEditing ? "0 0 0 0.3vmin rgba(177, 92, 214, 0.1)" : "none",
                backgroundColor: isTextEditing ? "white" : "#f5f4f4",
                borderRadius: "0.8vmin",
                padding: isMobile ? "8px" : "10px",
                resize: "none",
                fontFamily: "math",
                transition: "all 0.3s ease",
                width: "100%"
              }}
            />
          </div>

          {/* IMAGE SECTION */}
          <div style={{
            backgroundColor: "white",
            borderRadius: "2vmin",
            padding: isMobile ? "15px" : "20px",
            width: isMobile ? "100%" : "55%",
            boxShadow: "0 0.4vmin 1.6vmin rgba(0,0,0,0.1)",
          }}>
            <div className="d-flex justify-content-between align-items-center mb-2">
              <h5 style={{ 
                color: "#b15dc6",
                fontSize: isMobile ? "16px" : "18px",
                fontWeight: "bold"
              }}>Our Space</h5>

              {/* Only show Edit/Save buttons if we have data */}
              {hasData && !isImageEditing ? (
                <button onClick={() => setIsImageEditing(true)} style={{
                  border: "none",
                  background: "#ffffff",
                  color: "#b15cd6",
                  fontWeight: "bold",
                  cursor: "pointer",
                  padding: isMobile ? "4px 8px" : "5px 10px",
                  borderRadius: "0.6vmin",
                  border: "1px solid #b15cd6",
                  fontSize: isMobile ? "12px" : "14px"
                }}>
                  Edit Image
                </button>
              ) : hasData && isImageEditing ? (
                <button onClick={handleUpdate} style={{
                  background: "#b15cd6",
                  border: "none",
                  padding: isMobile ? "4px 10px" : "5px 12px",
                  borderRadius: "0.6vmin",
                  color: "#fff",
                  fontWeight: "bold",
                  cursor: "pointer",
                  fontSize: isMobile ? "12px" : "14px"
                }}>
                  Save
                </button>
              ) : null}
            </div>

            <div>
              <input
                ref={fileInputRef}
                type="file"
                accept="image/*"
                onChange={handleImageChange}
                style={{ display: "none" }}
              />

              <div
                onClick={handleImageClick}
                role={isImageEditing ? "button" : undefined}
                tabIndex={isImageEditing ? 0 : undefined}
                onKeyPress={(e) => {
                  if (isImageEditing && (e.key === "Enter" || e.key === " ")) {
                    handleImageClick();
                  }
                }}
                style={{ cursor: isImageEditing ? "pointer" : "default" }}
              >
                <Image
                  src={previewImage}
                  alt="About Us"
                  fluid
                  rounded
                  style={{
                    width: "100%",
                    height: getImageHeight(),
                    objectFit: "cover",
                    borderRadius: "1.2vmin",
                    border: isImageEditing ? "0.2vmin solid #b15cd6" : "none",
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </Row>

      {/* HIDE SCROLLBAR CSS */}
      <style>
        {`
          .hide-scrollbar::-webkit-scrollbar {
            display: none;
          }
          .hide-scrollbar {
            scrollbar-width: none;
          }
          
          @media (max-width: 768px) {
            .px-md-4 {
              padding-left: 1rem !important;
              padding-right: 1rem !important;
            }
            .p-md-4 {
              padding: 1.5rem !important;
            }
          }
          
          @media (max-width: 480px) {
            .abouts-page-name {
              font-size: 18px !important;
            }
          }
          
          @media(max-width:768px) {
            .addmargintop {
              margin-top: 2vh !important;
            }                  
          }
        `}
      </style>
    </Container>
  );
};

export default Cateringaboutus;